module.exports = __webpack_public_path__ + "static/media/gastronomy-products.ce7d619f.jpg";